import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Button } from "@heroui/react";
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks";
import { apiRoute, linksUrl } from "../../constants/enum";
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from "../../components";
import { COLUMN_ALIGN_TYPE, ROW_ACTION_BTN_TYPE } from "../../components/NextUITable";
import { toast } from "react-toastify";
import ConfirmBox from "../../components/ConfirmBox";
import { setDetailParams, setNewEntryMode } from "../../state/puritySlice";

const PurityMaster = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);

    // State for confirmation modal
    const [itemToDelete, setItemToDelete] = useState("")

    // Fetch purity data
    const {
        data: purityData = [],
        isPending,
        isError,
        mutate:filterData,
    } = usePost({
        url: apiRoute.purity.getpurity,
        queryKey: "fetchPurityMaster",
    });
    const funLoadData = () => {
            filterData({
                data: {}
            })
        }
        useEffect(() => {
            funLoadData();
        }, [])
    const sortedPurityData = [...purityData].sort((a, b) => a.Q_Ord - b.Q_Ord);


    const onSuccessDelete = () => {
        setItemToDelete("");
        funLoadData()
    };

    // Delete purity mutation
    const { mutate: deletePurity } = usePost({
        url: apiRoute.purity.deletePurity,
        queryKey: "deletePurityMaster",
        onSuccessTasks: onSuccessDelete,
        successMessage: "Purity deleted successfully!",
    });

    // Open confirmation box
    const handleDeleteClick = (Q_Code) => {
        if (!Q_Code) {
            toast.error("Error: purity Code is missing.");
            return;
        }
        else
        setItemToDelete(Q_Code)
        
           
    };

    const handleConfirmBox = (confirm) => {
        if (confirm && itemToDelete) {
            deletePurity({ data:{Q_Code: itemToDelete}});
        }
        else
        setItemToDelete("");
        
    };
    
    const handleAddNew = () => {
        dispatch(setNewEntryMode(true));
        dispatch(setDetailParams([])); 
        navigate(linksUrl.diamondParamater.purity.createPurityMaster);
    };
 const exportColumns = [
        {
            name: "PURITY CODE",
            uid: "Q_Code",
        },
        {
            name: "PURITY NAME",
            uid: "Q_Name",
        },
        {
            name: "PURITY GROUP",
            uid: "Q_Group",
        },
        {
            name: "PURITY ORDER",
            uid: "Q_Ord",
        },
        

    ]
    
    
    let downloadDataFooter = {
        Q_Code: "",
        Q_Name: "",
        Q_Group: "",
        Q_Ord: "",
    }

    const columns = [
        { name: "Actions", uid: "actions", align: COLUMN_ALIGN_TYPE.center },
        { name: "Purity Code", uid: "Q_Code", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Purity Name", uid: "Q_Name", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Purity Group", uid: "Q_Group", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Purity Order", uid: "Q_Ord", sortable: true, align: COLUMN_ALIGN_TYPE.center },
    ];

    const rowActionBtn = [
        {
            icon: <FontAwesomeIcon icon={faEdit} style={{ color: "#379906" }} />,
            onClick: (row) => {
                let obj={
                  Q_Code:row.Q_Code
                };
                dispatch(setDetailParams(obj));
                dispatch(setNewEntryMode(false))
                navigate(linksUrl.diamondParamater.purity.createPurityMaster);
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
        {
            icon: <FontAwesomeIcon icon={faTrash} style={{ color: "#c40c18" }} />,
            onClick: (row) => {
                handleDeleteClick(row.Q_Code);
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
    ];        

    if (isPending) return <LoadingCard/>;
    if (isError) return <ErrorCard/>;

    return (
        <div>
            <MainContainer pageName="Purity" breadcrumbs={["Diamond Parameter", "Purity Master"]}>
                <div className="text-right mb-4">
                    <Button size="sm" color="primary" startContent={<FontAwesomeIcon icon={faPlus} />} onPress={handleAddNew}>
                        Add New
                    </Button>
                </div>
                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={["actions", "Q_Code", "Q_Name", "Q_Group", "Q_Ord"]}
                    data={sortedPurityData}
                    columns={columns}
                    rowActionBtn={rowActionBtn}
                    downloadFileName="Purity-master-List"
                    exportColumns={exportColumns}
                    downloadDataFooter={downloadDataFooter}
                    showAdvanceFilter={false}
                    id="Q_Code"
                    
                />
            </MainContainer>

            {itemToDelete && itemToDelete!="" && <ConfirmBox handleConfirmBox={handleConfirmBox} />}
        </div>
    );
};

export default PurityMaster;
